import classNames from 'classnames';
import React from 'react';

import { getTranslation, keys } from '../../../Resources/Translations';
import { DiscountVariant } from '../../Blocks/DiscountVariant.csharp';

export enum StarInfoLabelColor {
    Red,
    Pink,
    DarkRed
}

interface StarInfoLabelProps {
    color: StarInfoLabelColor;
    variant: DiscountVariant;
    additionalInfo?: string;
    value: string;
    requiredQuantity?: number;
    paidQuantity?: number;
}

export const CircleInfoLabel: React.FunctionComponent<StarInfoLabelProps> = (props) => {
    return (
        <div className={`Label Label__Star Label__Star--${StarInfoLabelColor[props.color]} Label__Star--${DiscountVariant[props.variant]}`}>
            {props.additionalInfo && <span className="Label__AdditionalInfo">{props.additionalInfo}</span>}
            {props.requiredQuantity && props.paidQuantity ? (
                <div className={classNames('Label__FreeItemInfo', props.variant === DiscountVariant.Mini && 'Label__FreeItemInfo--Mini')}>
                    <span className={'Label__Value'}>{props.requiredQuantity}</span>
                    <span className={'Label__AdditionalInfo'}>{getTranslation(keys['cheapestForFreeDiscount.for'])}</span>
                    <span className={'Label__Value'}>{props.paidQuantity}</span>
                </div>
            ) : (
                <span className={classNames('Label__Value', props.additionalInfo && 'Label__Value--Small')}>{props.value}</span>
            )}
        </div>
    );
};
